import styled from "styled-components";

interface PillButtonProps {
  active?: boolean;
}

export const PillButton = styled.button<PillButtonProps>`
  display: flex;
  align-items: center;
  font-size: 10px;
  background-color: ${(props) =>
    props.active ? props.theme.selectedPill : props.theme.white};
  color: ${(props) =>
    props.active ? props.theme.pillText : props.theme.black};
  padding: 0.8rem 1.3rem;
  border-radius: 16px;
  border: none;
  margin: 0 8px 0 0;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  align-self: flex-start;
  flex: 1 auto 12rem;
  white-space: nowrap;
`;

export const PillButtonArrow = styled.div<PillButtonProps>`
  transform: ${(props) => (props.active ? "rotate(180deg)" : null)};

  img {
    display: block;
    width: 12px;
    height: 12px;
  }
`;
